import React from 'react';
import styled from 'styled-components';
import Element from './element';
import Wrapper from './wrapper';

const Title = ({ className, ...other }) => (
  <Wrapper className={className}>
    <Element {...other} />
  </Wrapper>
);

export default styled(Title)``;
